const usd = require('utilities/usd');
const Storage = require('utilities/storage');
const { storeCurrentSessionState } = require('utilities/cleanHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { getLanguage } = require('core/i18n').i18n;
const { cookiesDomain } = require('core/environmentConfig');
import { handleAuthentication } from 'ok-login';
const { SKIP_CLIENT_LOGIN_WHITELIST, DISASTER_RECOVERY_CUSTOMER_FINDER, AGENT_LOGIN_DISASTER, SESSION_ERROR_LEVEL } = require('constants/secureRouting');
const { TOKEN_CREDENTIAL } = require('constants/session');
const { LOCAL_ENVIRONMENT } = require('constants/index');


const setContactCenterConfig = (cookieInfo, payload) => {
    const { agentId, agentToken, clientPersonCode, clientPersonType, interactionId } = usd.getSecurityInfo();
    payload.bankToken = agentToken;
    payload.agentId = agentId;
    payload.interactionId = interactionId;
    payload.tipoPersona = clientPersonType;
    payload.codigoPersona = clientPersonCode;
    cookieInfo.credentialCookieName = usd.getCredentialCookieName(TOKEN_CREDENTIAL);
    cookieInfo.credentialCookieExpiration = usd.getCredentialCookieExpiration();
}

const getDestination = options => {
    const URL_PG = '/myprofile/global';
    const getNextPath = nextPathname => (!!nextPathname && nextPathname !== '/') ? nextPathname : URL_PG;
    const destination = options ? getNextPath(options.nextPathname) : URL_PG;
    return destination;
}

const onLoginSuccessContactCenter = (options, history) => () => {
    const token = Storage.cookies.get(TOKEN_CREDENTIAL);

    if (token) { // if for any reason the cookie wasn't generated avoid endless loading loop
        storeCurrentSessionState();
        let redirectPath;
        if (!__CONTACT_CENTER__) {
            redirectPath = SKIP_CLIENT_LOGIN_WHITELIST.includes(options.nextPathname) ? options.nextPathname : '/myprofile/global';
        } else {
            redirectPath = getDestination(options);
        }

        history.push(redirectPath);
    } else {
        history.push(SESSION_ERROR_LEVEL);
    }
}

const onLoginErrorContactCenter = (options, history) => response => {
    if (options.registerLoginErrorCallback) {
        options.registerLoginErrorCallback(response);
    }
    window.console.log(response);
    history.push(SESSION_ERROR_LEVEL);
};

const getLoginUserOptions = (options, history) => {
    const defaultOptions = {
        profileSuccess: () => {},
        containerSelector: null
    };

    options = Object.assign({}, defaultOptions, options);

    let userTokenURL = 'requestUserToken';
    let payload = {
        force: true
    };
    let cookieInfo = {};

    userTokenURL =  'requestUserTokenContactCenter';
    setContactCenterConfig(cookieInfo, payload);

    let config = {
        lang: getLanguage(),
        country: 'es', // Initially hardcoded
        container: options.containerSelector,
        authentication: {
            url: apiURLBuilder.getURL(userTokenURL),
            headers: {},
            payload: payload
        },
        offlog: {
            url: apiURLBuilder.getURL('generateOfflogToken'),
            headers: {}
        },
        profile: {
            url: apiURLBuilder.getURL('userProfile'),
            headers: {}
        },
        onLoginError: options.onLoginError ? options.onLoginError : onLoginErrorContactCenter(options, history),
        onLoginSuccess: options.onLoginSuccess ? options.onLoginSuccess : onLoginSuccessContactCenter(options, history),
        cookieInfo,
        useLocalStorage: !!__CONTACT_CENTER__
    }

    if (window.__ENV__ !== LOCAL_ENVIRONMENT){
        config.cookiesDomain = cookiesDomain;
    }

    return config;
}

const executeSharedLogin = (options, history) => {
    const { interactionId, agentToken, isDisasterRecovery } = usd.getSecurityInfo()
    const IS_DISASTER_RECOVERY = isDisasterRecovery;
    const NO_CLIENT_DISASTER = (IS_DISASTER_RECOVERY && interactionId === "");
    const NO_AGENT_DISASTER = (IS_DISASTER_RECOVERY && agentToken === "");
    if (!IS_DISASTER_RECOVERY || (!NO_CLIENT_DISASTER && !NO_AGENT_DISASTER)) {
        const userOptions = getLoginUserOptions(options, history);
        handleAuthentication(userOptions);
    } else if (IS_DISASTER_RECOVERY && NO_AGENT_DISASTER) {
        history.push(AGENT_LOGIN_DISASTER);
    } else if (IS_DISASTER_RECOVERY && NO_CLIENT_DISASTER && !NO_AGENT_DISASTER) {
        history.push(DISASTER_RECOVERY_CUSTOMER_FINDER);
    }
}

module.exports = {
    executeSharedLogin,
};
